import React from 'react'
import { FeatureFlagName } from '../../_constants/featureFlags'
import FeatureFlag from '../../components/atoms/FeatureFlag'
import StandardLoginPage from './StandardLoginPage'
import SSOLoginPage from './SSOLoginPage'

/**
 * Login Page Router - decides which login page to show based on SSO feature flag
 * This eliminates the need for feature flag checks within the login pages themselves
 */
const LoginPage: React.FC = () => {
  return (
    <FeatureFlag flagName={FeatureFlagName.SSO_LOGIN} fallback={<StandardLoginPage />}>
      <SSOLoginPage />
    </FeatureFlag>
  )
}

export default LoginPage
